import { Representante } from './representante';
import { Ano } from './ano';

/** Dados dos KPIs de produtividade dos representantes */
export class Produtividade {
    representantes: Representante[];
    anos: Ano[];

    constructor(props: Partial<Produtividade>) {
        Object.assign(this, props);

        if (props) {
            // Representantes
            this.constructorRepresentantes(props.representantes);
            // Anos
            this.constructorAnos(props.anos);
        }
    }

    /** Constructor para os anos */
    private constructorAnos(anos: Ano[]) {
        if (anos && Array.isArray(anos)) {
            this.anos = anos.map(ano => new Ano(ano));
        } else {
            this.anos = [];
        }
    }

    /** Constructor para os representantes */
    private constructorRepresentantes(representantes: Representante[]) {
        if (representantes && Array.isArray(representantes)) {
            this.representantes = representantes.map(representante => new Representante(representante));
        } else {
            this.representantes = [];
        }
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Produtividade {
        return new Produtividade(JSON.parse(json));
    }
}
